const manufacturers_select = () => {

    $('.manufacturers-select').select2({
        width: 'auto',
        selectionCssClass: 'manufacturers__custom-select',
        dropdownCssClass: 'manufacturers__custom-dropdown',
        data: [
            { id: 'default', text: 'Select manufacturer', selected: true, disabled: true },
        ],
    });


    $('.manufacturers-select').on('change', function() {
        let selectedOption = $(this).find(':selected');
        let link = selectedOption.data('link');
    
        if (link) {
            window.location.href = link;
        }
    });

}

export default manufacturers_select;